import { render } from "./LwCelebration.vue?vue&type=template&id=a7641928&scoped=true"
import script from "./LwCelebration.vue?vue&type=script&lang=js"
export * from "./LwCelebration.vue?vue&type=script&lang=js"

import "./LwCelebration.vue?vue&type=style&index=0&id=a7641928&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7641928"]])

export default __exports__